import React, { useEffect, useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { ICorporateEvent } from "../../../../../interfaces/corporateEvent";
import DetailsTabContent from "../tabs/DetailsTabContent";
import ScheduleLocationsTabContent from "../tabs/ScheduleLocationsTabContent";
import AdditionalInfoTabContent from "../tabs/AdditionalInfoTabContent";
import IsMobile from "../../../../../hooks/isMobile";
import { getEventValuesCMSThunk } from "../../../../../store/events/eventThunk";
import { useAppDispatch } from "../../../../../hooks/storeHooks";
import "./eventTabContent.scss";

interface EventTabContentProps {
	corporateEventDetail: ICorporateEvent;
	OnClickTriggerLeftContainerScroll?: () => void;
}

type EventSubTab = "details" | "schedule-locations" | "additional-info";

const EventTabContent: React.FC<EventTabContentProps> = ({
	corporateEventDetail,
	OnClickTriggerLeftContainerScroll,
}) => {
	const isMobile = IsMobile();
	const [selectedSubTab, setSelectedSubTab] = useState<EventSubTab>("details");
	const dispatch = useAppDispatch();

	const handleSubTabChange = (event: React.SyntheticEvent, newValue: EventSubTab) => {
		setSelectedSubTab(newValue);
	};

	useEffect(() => {
		dispatch(getEventValuesCMSThunk({}));
	}, []);

	return (
		<Box className="eventTabContent">
			{/* Sub Tabs */}
			<Box className="subTabsContainer">
				<Tabs
					value={selectedSubTab}
					onChange={(event, newValue) => {
						handleSubTabChange(event, newValue);
						OnClickTriggerLeftContainerScroll?.();
					}}
					className="subTabs"
					classes={{
						list: "subTabsFlexContainer",
					}}
					slotProps={{
						indicator: {
							style: {
								display: isMobile ? "block" : "none",
							},
						}
					}}
				>
					<Tab
						label="Details"
						value="details"
						className={`subTab ${selectedSubTab === "details" ? "active" : ""}`}
					/>
					<Tab
						label="Schedule & Locations"
						value="schedule-locations"
						className={`subTab ${selectedSubTab === "schedule-locations" ? "active" : ""}`}
					/>
					<Tab
						label="Additional Information"
						value="additional-info"
						className={`subTab ${selectedSubTab === "additional-info" ? "active" : ""}`}
					/>
				</Tabs>
			</Box>

			{/* Sub Tab Content */}
			<Box className="subTabContent">
				{selectedSubTab === "details" && <DetailsTabContent corporateEventDetail={corporateEventDetail} />}
				{selectedSubTab === "schedule-locations" && (
					<ScheduleLocationsTabContent
						corporateEventDetail={corporateEventDetail}
						OnClickTriggerLeftContainerScroll={OnClickTriggerLeftContainerScroll}
					/>
				)}
				{selectedSubTab === "additional-info" && (
					<AdditionalInfoTabContent
						attachments={corporateEventDetail?.attachments}
						notes={corporateEventDetail?.notes}
					/>
				)}
			</Box>
		</Box>
	);
};

export default EventTabContent;
